import { z } from 'zod';

// Per-user persistent inbox. Every notify* helper in
// services/notifications.ts mirrors a row in the notification collection so
// the recipient sees a record even if email delivery fails.
//
// kind is open-ended on purpose — adding a new event later doesn't require a
// schema migration. Each kind ships with a UI mapping (icon + tone) on the
// client side; new kinds without a mapping fall back to neutral.
export const NOTIFICATION_KINDS = [
  'proposal_sent',
  'proposal_accepted',
  'proposal_declined',
  'invoice_issued',
  'invoice_paid',
  'payment_refunded',
  'document_published',
  'request_status_changed',
  'support_ticket_replied',
  'lead_changed',
  'contact_invited',
  'contact_activated',
  // Portal-KYC kinds — wired by Phase F (notification helpers + tone mapping).
  // Registered here so types are stable for Phases A–E.
  'kyc_submission_received',
  'kyc_doc_accepted',
  'kyc_doc_rejected',
  'kyc_finalised',
] as const;
export const NotificationKindSchema = z.enum(NOTIFICATION_KINDS);
export type NotificationKind = z.infer<typeof NotificationKindSchema>;

export const NotificationDtoSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  kind: NotificationKindSchema,
  title: z.string(),
  body: z.string(),
  href: z.string(),
  related_resource: z.string().nullable(),
  related_id: z.string().nullable(),
  read_at: z.string().nullable(),
  created_at: z.string(),
});
export type NotificationDto = z.infer<typeof NotificationDtoSchema>;
